import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getMatchingClassificationBadges } from '../../../utils/helpers';
import './matchingBadges.scss';

const MatchingBadge = ({ itemClassifications, filters, classifications }) => {
  const [badgeLimit, setBadgeLimit] = useState(3);
  const badges = useMemo(
    () =>
      getMatchingClassificationBadges(
        itemClassifications,
        classifications,
        filters.selectedPrimaryClassifications,
        filters.selectedSecondaryClassifications,
        // eslint-disable-next-line react-hooks/exhaustive-deps
      ),
    [],
  );

  if (!badges) return null;

  return (
    <div className="vf-result__badge-container">
      {badges.map(
        (badge, i) =>
          i < badgeLimit && (
            <span className="vf-result__badge-container__badge" key={badge}>
              {badge}
            </span>
          ),
      )}
      {badges.length > badgeLimit && (
        <div
          role="button"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.keycode === 13) {
              setBadgeLimit(badges.length);
            }
          }}
          onClick={() => setBadgeLimit(badges.length)}
          className="vf-result__badge-container__toggle-all"
        >
          +{badges.length - badgeLimit}
        </div>
      )}
    </div>
  );
};

MatchingBadge.propTypes = {
  itemClassifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  filters: PropTypes.shape({
    selectedPrimaryClassifications: PropTypes.arrayOf(PropTypes.string),
    selectedSecondaryClassifications: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  classifications: PropTypes.shape({}).isRequired,
};

export default MatchingBadge;
